var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "mx-auto",
      class: {
        "section-invert": _vm.black && !_vm.isolated,
        section: !_vm.black && !_vm.isolated,
        "py-10": !_vm.black,
        "mobile-maxheight": _vm.$uiHelpers.isMobile
      },
      attrs: { id: "contact-form" }
    },
    [
      _c(
        "b-col",
        {
          class: {
            "bg-black": _vm.black,
            "my-lg-auto mt-sm-auto pr-lg-5 mb-4 mb-sm-0": true,
            mobile: _vm.$uiHelpers.isMobile
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("h3", [_vm._v(" " + _vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.subtitle
            ? _c(
                "p",
                { class: { "mobile-subtitle": _vm.$uiHelpers.isMobile } },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.subtitle ||
                          _vm.$t("companies-contact-form.subtitle", {
                            serviceType: _vm.serviceType
                          })
                      ) +
                      "\n\t\t\t"
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "pl-lg-5",
          class: {
            "mobile-form": _vm.$uiHelpers.isMobile,
            "os-bg-white": _vm.black,
            "my-auto": !_vm.black
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("div", { class: { "py-sm-10 pl-sm-5": _vm.black } }, [
            _c(
              "div",
              [
                (_vm.forIndividuals ||
                  (!_vm.forIndividuals && !_vm.forIndividualsOnly)) &&
                !_vm.forCompaniesOnly
                  ? _c("base-select", {
                      staticClass: "mb-4",
                      attrs: {
                        state: _vm.validateState("entityType"),
                        options: _vm.formOptions.entityTypes,
                        placeholder: _vm.$t(
                          "companies-contact-form.form.select-single-or-business"
                        )
                      },
                      model: {
                        value: _vm.form.entityType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "entityType", $$v)
                        },
                        expression: "form.entityType"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "pr-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("firstName"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.name"
                            )
                          },
                          model: {
                            value: _vm.form.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "firstName", $$v)
                            },
                            expression: "form.firstName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("lastName"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.surnames"
                            )
                          },
                          model: {
                            value: _vm.form.lastName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lastName", $$v)
                            },
                            expression: "form.lastName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _vm.isCompany
                      ? _c(
                          "b-col",
                          {
                            staticClass: "pr-lg-2",
                            attrs: { lg: "6", md: "12" }
                          },
                          [
                            _c("base-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "companies-contact-form.form.company"
                                ),
                                state: _vm.validateState("company")
                              },
                              model: {
                                value: _vm.form.company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "company", $$v)
                                },
                                expression: "form.company"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("email"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.email"
                            )
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "pr-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("phone"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.phone-number"
                            )
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "phone", $$v)
                            },
                            expression: "form.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isCompany && !_vm.hideEmployeesNumber
                      ? _c(
                          "b-col",
                          { attrs: { lg: "6", md: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.validateState("employeesNumber"),
                                placeholder: _vm.$t(
                                  "companies-contact-form.form.employees-number"
                                )
                              },
                              model: {
                                value: _vm.form.employeesNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "employeesNumber", $$v)
                                },
                                expression: "form.employeesNumber"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _vm.countryOptions
                          ? _c("base-select", {
                              staticClass: "mb-4",
                              attrs: {
                                placeholder: _vm.$t("signupOH.country"),
                                options: _vm.countryOptions,
                                clearable: false
                              },
                              model: {
                                value: _vm.form.country,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "country", $$v)
                                },
                                expression: "form.country"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showCollegiateNumber
                  ? _c("base-input", {
                      attrs: {
                        state: _vm.validateState("collegiateNumber"),
                        placeholder: _vm.$t(
                          "companies-contact-form.form.collegiateNumber"
                        )
                      },
                      model: {
                        value: _vm.form.collegiateNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "collegiateNumber", $$v)
                        },
                        expression: "form.collegiateNumber"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDescription
                  ? _c("base-textarea", {
                      attrs: {
                        state: _vm.validateState("description"),
                        placeholder: _vm.$t("openlegal.explain-case")
                      },
                      model: {
                        value: _vm.form.description,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "description", $$v)
                        },
                        expression: "form.description"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showReason
                  ? _c("base-textarea", {
                      staticClass: "mt-2",
                      attrs: {
                        state: _vm.validateState("reason"),
                        placeholder: _vm.$t(
                          "companies-contact-form.form.form-reason"
                        )
                      },
                      model: {
                        value: _vm.form.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "reason", $$v)
                        },
                        expression: "form.reason"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "companies-contact-form.form.disclaimers.personal",
                          { platform: _vm.platform }
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { state: _vm.validateState("privacyPolicy") },
                    model: {
                      value: _vm.form.privacyPolicy,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "privacyPolicy", $$v)
                      },
                      expression: "form.privacyPolicy"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "companies-contact-form.form.disclaimers.privacy"
                          )
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    attrs: { outline: "", black: "" },
                    on: { click: _vm.sendContactForm }
                  },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fafd3b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fafd3b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/CompaniesContactForm.vue
// module id = 2521
// module chunks = 10 12 35 36 39 40 41 42 44 52